import { SPEAKERS } from "@/data/siteData";
import { ArrowUpRight } from "lucide-react";

export const Speakers = () => {
  return (
    <section id="speakers" data-testid="speakers-section" className="border-b border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-6 items-end mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-7">
            <div className="overline text-[#FF2A00] mb-4">/ 04 — Keynote Speakers</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase tracking-tighter">
              Builders,
              <br />
              not bystanders.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="text-zinc-600">
              Hand-picked operators who ship at scale, publish original research, and
              lead the teams keeping the internet online.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-l border-zinc-200">
          {SPEAKERS.map((s, i) => (
            <article
              key={i}
              data-testid={`speaker-card-${i}`}
              className="group border-r border-b border-zinc-200 bg-white hover:bg-zinc-50 transition-colors"
            >
              <div className="aspect-[4/5] overflow-hidden bg-[#0a1a3a] relative">
                {s.img ? (
                  <img
                    src={s.img}
                    alt={s.name}
                    loading="lazy"
                    className="w-full h-full object-contain"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-zinc-100">
                    <span className="overline text-zinc-300 text-[10px]">Photo</span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg uppercase tracking-tight">{s.name}</h3>
                <div className="text-sm text-zinc-700 mt-1">
                  {s.title}, <span className="text-zinc-500">{s.org}</span>
                </div>
                <div className="mt-4 pt-4 border-t border-zinc-100 flex items-start justify-between gap-3">
                  <div className="overline text-zinc-500 leading-relaxed">{s.topic}</div>
                  <ArrowUpRight size={16} className="text-[#002FA7] mt-0.5 shrink-0" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Speakers;
